import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import ContentPreloader from '$components/student/ContentPreloader';
import styles from './styles.scss';

class NextContentButton extends Component {
  render() {
    const { contentInstance, flatContent } = this.props;

    const contentIndex = _findIndex(flatContent, contentInstance);
    const pastContent = flatContent.slice(0, contentIndex).reverse();
    const prevContent = _find(pastContent, (obj) => _isEmpty(obj.content));

    if (!prevContent) {
      // 20190210JP: We do still want a spacer.
      return <div style={{ minWidth: '80px' }} />;
    }

    return (
      <Button data-aaa="previousContentButton">
        <ContentPreloader uuid={prevContent.uuid} />
        <Link to={prevContent.path}>
          <span className={styles.navigationDetail}>&larr; </span>Previous
        </Link>
      </Button>
    );
  }
}

export default NextContentButton;
